<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("apps.gworkitemhis") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row mt-3">
              <div class="col-auto">
                <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                <input
                  v-model="refNumber"
                  type="text"
                  class="form-control"
                  style="width: 280px"
                  placeholder="เลขที่ตั๋ว"
                  @keyup.enter="onSearch"
                />
              </div>
              <div class="col-auto">
                <label class="form-label ms-0 invisible">x</label>
                <div>
                  <material-button
                    id="workItemSearch"
                    color="success"
                    class="mb-0"
                    :disabled="loading || !refNumber.trim()"
                    @click="onSearch"
                  >
                    <i class="material-icons material-symbols-outlined">search</i>
                    {{ $t("buttons.sear") }}
                  </material-button>
                </div>
              </div>
            </div>

            <!-- workCase info bar -->
            <div v-if="workCaseInfo" class="row mt-3">
              <div class="col-12">
                <div class="alert py-2 mb-0 d-flex flex-wrap gap-3" style="background-color: #d4edda; color: #155724; border-color: #c3e6cb;">
                  <span><strong>{{ $t("content.ticketno") }}:</strong> {{ searchedRef }}</span>
                  <span><strong>{{ $t("content.names") }}:</strong> {{ workCaseInfo.tkCustomerInfo ? workCaseInfo.tkCustomerInfo.name : '-' }}</span>
                  <span><strong>{{ $t("content.trans") }}:</strong> {{ checkTransaction(workCaseInfo.transactionType) }}</span>
                  <span><strong>สถานะตั๋ว:</strong> {{ checkStatus(workCaseInfo.status) }}</span>
                </div>
              </div>
            </div>

            <hr v-if="historyList.length > 0 || searched" />

            <!-- no result -->
            <div v-if="searched && historyList.length === 0 && !loading" class="row mt-3">
              <div class="col-12 text-center text-muted py-4">
                <i class="material-icons material-symbols-outlined" style="font-size:48px">history</i>
                <p class="mt-2">{{ $t("content.nodata") }}</p>
              </div>
            </div>

            <!-- history table -->
            <div v-if="historyList.length > 0" class="row mt-3">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-flush">
                    <thead class="thead-light">
                      <tr>
                        <th>#</th>
                        <th>{{ $t("apps.gworkitemstepcode") }}</th>
                        <th>{{ $t("apps.gworkitemstep") }}</th>
                        <th>{{ $t("apps.gworkitemcompletetime") }}</th>
                        <th>{{ $t("apps.gworkitemcompleteuser") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in historyList" :key="index">
                        <td class="text-sm font-weight-normal">{{ index + 1 }}</td>
                        <td class="text-sm font-weight-normal">{{ item.stepCode || '-' }}</td>
                        <td class="text-sm font-weight-normal">{{ item.stepName || item.step || '-' }}</td>
                        <td class="text-sm font-weight-normal">{{ formatDate(item.completeTime) }}</td>
                        <td class="text-sm font-weight-normal">{{ item.completeUserName || '-' }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                          <td colspan="9" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { ref } from "vue";
import { useWorkCaseStore } from "@/stores/workcase";
import { useWorkItemStore } from "@/stores/workItem";
import MaterialButton from "@/components/MaterialButton.vue";
import moment from "moment";

const storewc = useWorkCaseStore();
const storewi = useWorkItemStore();

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const loading = ref(false);
const searched = ref(false);
const refNumber = ref("");
const searchedRef = ref("");
const workCaseInfo = ref(null);
const historyList = ref([]);
const totalRows = ref(0);
const totalRows_s = ref('');


async function onSearch() {
  totalRows_s.value = ''
  if (!refNumber.value.trim()) return;

  loading.value = true;
  searched.value = false;
  searchedRef.value = refNumber.value.trim();
  workCaseInfo.value = null;
  historyList.value = [];

  try {
    const infoResp = await storewc.workCaseInfoByRefFetch({
      groupUid: key.groupUid,
      shopUid: key.uid,
      refNumber: refNumber.value.trim(),
    });

    if (infoResp?.status === 200 && infoResp.data?.rtnDesc === "success") {
      const wc = infoResp.data.data;
      workCaseInfo.value = wc;

      const workItemUid = wc?.workItems?.[0]?.uid;
      if (!workItemUid) {
        searched.value = true;
        return;
      }

      const histResp = await storewi.workItemHistoryRptFetch({
        index: "0",
        size: "100",
        groupUid: key.groupUid,
        shopUid: key.uid,
        uid: workItemUid,
      });

      if (histResp?.status === 200 && histResp.data?.rtnDesc === "success") {
        historyList.value = histResp.data.data?.list ?? histResp.data.data ?? [];
        totalRows.value = histResp.data.data?.total ?? historyList.value.length;
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  } catch (e) {
    console.error("workItemHistory error:", e);
  } finally {
    loading.value = false;
    searched.value = true;
  }
}

function formatDate(val) {
  if (!val) return "-";
  return moment(val).format("DD/MM/YYYY HH:mm:ss");
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function checkTransaction(type) {
  const map = {
    PAWN: "จำนำ",
    INTEREST: "ต่อดอก",
    REDEEM: "ไถ่ถอน",
    INC_PRINCIPLE: "เพิ่มต้น",
    DEC_PRINCIPLE: "ลดต้น",
  };
  return map[type] ?? type ?? "-";
}

function checkStatus(status) {
  const map = {
    ACTIVE: "กำลังดำเนินการ",
    FINISH: "เสร็จสิ้น",
    FREEZE: "อายัด",
    TERMINATE: "ยกเลิก",
    BREAKING: "ของหลุด",
  };
  return map[status] ?? status ?? "-";
}

function checkItemStatus(status) {
  const map = {
    COMPLETE: "สำเร็จ",
    PENDING: "รอดำเนินการ",
    SKIP: "ข้าม",
    CANCEL: "ยกเลิก",
    ACTIVE: "กำลังดำเนินการ",
  };
  return map[status] ?? status ?? "-";
}

function statusBadge(status) {
  const map = {
    COMPLETE: "badge badge-sm bg-gradient-success",
    PENDING: "badge badge-sm bg-gradient-warning",
    SKIP: "badge badge-sm bg-gradient-secondary",
    CANCEL: "badge badge-sm bg-gradient-danger",
    ACTIVE: "badge badge-sm bg-gradient-info",
  };
  return map[status] ?? "badge badge-sm bg-gradient-secondary";
}
</script>
